import React, { useMemo } from 'react';
import { Title, Icon } from 'ui-library';
import { Link } from 'react-router-dom';

import {
    ICON_DOWNLOAD,
    ICON_TYPE_OPEN_SQUARE,
} from 'ui-library/components/Icon';
import { isImageFormat, isPdfFormat } from 'utils/file';
import PdfFirstPageToPng from 'components/UploadDocuments/PdfFirstPageToPng';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import './SystemMessagePreview.css';

const SystemMessagePreview = ({
    title, body, link, document,
}) => {
    const { t } = useTranslation();

    const pdfUrl = useMemo(() => {
        if (document) {
            return URL.createObjectURL(document);
        }

        return null;
    }, [document]);

    return (
        <div className="system-message-preview">
            <Title type={2} className="font-normal mb-24">
                {title}
            </Title>
            {body?.split('\n')?.map((para, index) => (
                <p key={index}>{para}</p>
            ))}
            {link && (
                <div className="mt-24">
                    <Link to={link} target="_blank" rel="noopener noreferrer">
                        {link}
                        <Icon
                            className="ml-8"
                            size={12}
                            type={ICON_TYPE_OPEN_SQUARE}
                        />
                    </Link>
                </div>
            )}

            {document
                && (typeof document === 'string' ? (
                    <div className="system-message-document">
                        <img src={document} alt="system-message-document" />
                    </div>
                ) : (
                    <>
                        {isImageFormat(document) && (
                            <div className="system-message-document">
                                <img
                                    src={DOMPurify.sanitize(
                                        pdfUrl || '',
                                    )}
                                    alt="system-message-document"
                                />
                            </div>
                        )}
                        {isPdfFormat(document) && (
                            <PdfFirstPageToPng
                                pdfUrl={pdfUrl || ''}
                            />
                        )}
                    </>
                ))}

            {document && isPdfFormat(document) && (
                <div className="mb-24 mt-24 text-center">
                    <a
                        href={DOMPurify.sanitize(pdfUrl || '')}
                        download={`${document.name}`}
                    >
                        <Icon className="mr-8" size={18} type={ICON_DOWNLOAD} />
                        {t('SystemMessage.Preview.DownloadDocument')}
                    </a>
                </div>
            )}
        </div>
    );
};

export default SystemMessagePreview;
